/** Mirrors backend `io.mirai.core.base.entity.Role` JSON values. */
export enum Role {
  Admin = 'Admin',
  Tenant = 'Tenant',
}

export interface User {
  id: string;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  role: Role;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export type AuthStatus = 'idle' | 'booting' | 'authenticated' | 'unauthenticated';

export interface AppError {
  status: number | 'FETCH_ERROR' | 'PARSING_ERROR' | 'TIMEOUT_ERROR' | 'CUSTOM_ERROR';
  code: string;
  message: string;
  validations?: ValidationError[];
  original?: unknown;
}

export interface ValidationError {
  name: string,
  error: string,
}
